import { render, staticRenderFns } from "./DebitoBNC.vue?vue&type=template&id=f99a015c"
import script from "./DebitoBNC.vue?vue&type=script&lang=js"
export * from "./DebitoBNC.vue?vue&type=script&lang=js"
import style0 from "./DebitoBNC.vue?vue&type=style&index=0&id=f99a015c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports